import { FaArrowRightLong } from "react-icons/fa6"
import Heading from "../components/heading"
import { useRef, useState } from "react"
// import poster from "../assets/ISS.png"
import { FaPause, FaPlay } from "react-icons/fa"
import { Link } from "react-router-dom"
// import axios from "axios"
// import { apis } from "../api/apiUrl"
// import { useInView } from "framer-motion"
// import curve from "../assets/curve.svg"
// import vid from "../assets/hero.mp4"
const InternationalOffice = () => {

    const poster = "/assets/ISS.png"
    const curve = "/assets/curve.svg"
    // const vid = "/assets/hero.mp4"
    const [data,] = useState({
        title: "International Office",
        description: "UNITEN International Office (IO) is an important centre for all international students. It is responsible for the general welfare of all international students at UNITEN.",
        videoLink: "/assets/hero.mp4"
    })
    const [loading,] = useState(false)
    const ref = useRef(null)
    // const isInViewRef = useInView(ref, { once: true });
    // useEffect(() => {
    //     async function fetchData() {
    //         const response = await axios.get(apis.baseUrl + apis.getInternationalOffice);
    //         setData({
    //             title: response?.data.internationalOffice.title,
    //             description: response?.data.internationalOffice.description,
    //             videoLink: response?.data.internationalOffice.videoLink
    //         }
    //         );
    //         setLoading(false)
    //     }
    //     if(isInViewRef){
    //         fetchData();

    //     }
    // }, [isInViewRef]);

    const videoRef = useRef(null)
    const [play, setPlay] = useState(false)
    const onPlay = () => {
        videoRef.current.play()
        setPlay(true)
    }
    const onPause = () => {
        videoRef.current.pause()
        setPlay(false)
    }

    return (
        <div ref={ref} className="relative bg-white flex flex-col">
            <div className="bg-[#191d26] text-white flex items-start justify-center p-4 2xl:pt-16">
                <div className="md:max-w-6xl w-full  flex flex-col items-start 2xl:max-w-[95rem]   p-4 gap-3 2xl:gap-8">
                    <Heading name="International Office" />
                    {
                        loading ?
                            <h1 className="text-2xl h-10 bg-gray-500 animate-pulse rounded-full font-bold md:w-[30rem] 2xl:w-[55rem] 2xl:text-5xl "></h1>
                            :
                            <h1 className="text-2xl font-bold md:w-[30rem] 2xl:w-[55rem] 2xl:text-5xl ">{data?.title}</h1>
                    }

                    <div className="flex gap-12 flex-col md:flex-row  items-start md:items-center w-full justify-between">

                        {
                            loading ?
                                <p className="text-xs text-gray-400 h-8 bg-gray-500 animate-pulse rounded-full 2xl:text-[16px] w-full md:w-[40rem] 2xl:w-[50rem] 2xl:leading-7"></p>

                                :
                                <p className="text-xs text-gray-400 2xl:text-[16px] w-full md:w-[40rem] 2xl:w-[50rem] 2xl:leading-7">{data?.description}</p>
                        }


                        <Link to="/international office" className="flex gap-1 items-center p-2 px-3 2xl:text-[16px] 2xl:leading-7 rounded-sm bg-[#9c0000] text-white w-fit text-xs whitespace-nowrap">
                            Explore Now
                            <FaArrowRightLong />
                        </Link>

                    </div>
                    <div className="flex w-full items-center justify-center ">
                        <div className=" 2xl:max-w-full w-full h-full flex flex-col items-center justify-between  gap-5">
                            <div className="w-full rounded-lg relative overflow-hidden flex flex-1  mt-2 group">
                                <video ref={videoRef} poster={poster} muted className="rounded-lg aspect-video object-cover w-full h-auto">
                                    <source src={data?.videoLink} type="video/mp4" />
                                </video>
                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 transition-all ">
                                    {
                                        play ?
                                            <button aria-label="btnPause" className="text-[#f3f3f3] hidden group-hover:block" onClick={onPause}><FaPause size={40} /></button>
                                            : <button aria-label="btnPlay"  className="text-[#f3f3f3]" onClick={onPlay}><FaPlay size={40} /></button>
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col items-center gap-3 2xl:gap-5">
                                <Heading name="International Office" />
                                <h1 className="text-2xl font-bold text-center 2xl:text-[48px] 2xl:leading-10">International Student Services (ISS)</h1>
                                <p className="text-xs text-gray-400 text-center md:w-[75%] 2xl:w-[50%] 2xl:text-[16px] 2xl:leading-7">UNITEN International Office (IO) is an important centre for all international
                                    students. It is responsible for the general welfare of all international
                                    students at UNITEN.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src={curve} width="100%" height={1000} className="bg-[#191d26]" alt="photo"/>
        </div >
    )
}

export default InternationalOffice